import React from 'react';
import { Card } from 'react-bootstrap';
import { Button, Col, Row } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';
import ComplementoComercioExteriorMercanciasResumen from './ComplementoComercioExteriorMercanciasResumen';
import ComplementoComercioExteriorPropietarioResumen from './ComplementoComercioExteriorPropietarioResumen';
import ComplementoComercioExteriorDestinatarioResumen from './ComplementoComercioExteriorDestinatarioResumen';

const labels = [
  {
    label: 'Motivo Traslado',
    index: 'MotivoTraslado'
  },
  {
    label: 'Tipo Operación',
    index: 'TipoOperacion',
    render: () => {
      return '2'
    }
  },
  {
    label: 'Clave de Pedimento',
    index: 'ClaveDePedimento',
    render: () => {
      return 'A1'
    }
  },
  {
    label: 'Subdivisión',
    index: 'Subdivision',
    render: () => {
      return '0'
    }
  },
  {
    label: 'Certificado Origen',
    index: 'CertificadoOrigen'
  },
  {
    label: 'Número Certificado Origen',
    index: 'NumCertificadoOrigen'
  },
  {
    label: 'Número Exportador Confiable',
    index: 'NumeroExportadorConfiable'
  },
  {
    label: 'Incoterm',
    index: 'Incoterm'
  },
  {
    label: 'Tipo Cambio USD',
    index: 'TipoCambioUSD'
  },
  {
    label: 'Total USD',
    index: 'TotalUSD'
  }
];

const labelsEmisor = [
  {
    label: 'Curp',
    index: 'Emisor.Curp'
  },
];

const labelsEmisorDomicilio = [
  {
    label: 'Calle',
    index: 'Emisor.Domicilio.Calle',
  },
  {
    label: 'Estado',
    index: 'Emisor.Domicilio.Estado',
  },
  {
    label: 'País',
    index: 'Emisor.Domicilio.Pais',
  },
  {
    label: 'Código Postal',
    index: 'Emisor.Domicilio.CodigoPostal',
  }
];

const labelsReceptor = [
  {
    label: 'NumRegIdTrib',
    index: 'Receptor.NumRegIdTrib'
  },
];

const labelsReceptorDomicilio = [
  {
    label: 'Calle',
    index: 'Receptor.Domicilio.Calle',
  },
  {
    label: 'Estado',
    index: 'Receptor.Domicilio.Estado',
  },
  {
    label: 'País',
    index: 'Receptor.Domicilio.Pais',
  },
  {
    label: 'Código Postal',
    index: 'Receptor.Domicilio.CodigoPostal',
  }
];

const ComplementoComercioExteriorResumen = ({ data = {}, onEdit, onDelete }) => {
  const handleOnDelete = () => {
    onDelete('ComercioExterior');
  }

  const handleOnEdit = () => {
    onEdit('ComercioExterior', data);
  }

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  const renderPropietario = (item) => (
    <ComplementoComercioExteriorPropietarioResumen key={ item.id } data={ item } className="mb-2" />
  )

  const renderDestinatario = (item) => (
    <ComplementoComercioExteriorDestinatarioResumen key={ item.id } data={ item } className="mb-2" />
  )

  const renderMercancias = (item) => (
    <ComplementoComercioExteriorMercanciasResumen key={ item.id } data={ item } className="mb-2" />
  )

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          Comercio Exterior, Versión { data.Version }
        </Card.Subtitle>

        <Row>
          <Col>
            { labels.map(renderLeyends) }
          </Col>
        </Row>

        <div className="d-block mt-3 mb-2">
          <strong>Emisor</strong>
        </div>

        <Row>
          <Col>
            { labelsEmisor.map(renderLeyends) }
          </Col>
        </Row>

        <div className="d-block mt-1 mb-1">
          <strong>Domicilio</strong>
        </div>

        <Row>
          <Col>
            { labelsEmisorDomicilio.map(renderLeyends) }
          </Col>
        </Row>

        <div className="d-block mt-3 mb-2">
          <strong>Receptor</strong>
        </div>

        <Row>
          <Col>
            { labelsReceptor.map(renderLeyends) }
          </Col>
        </Row>

        <div className="d-block mt-2 mb-1">
          <strong>Domicilio</strong>
        </div>

        <Row>
          <Col>
            { labelsReceptorDomicilio.map(renderLeyends) }
          </Col>
        </Row>

        { !!data.Propietario && (
          <>
            <div className="d-block mt-3 mb-2">
              <strong>Propietario</strong>
            </div>

            { !!data.Propietario && data.Propietario.map(renderPropietario) }
          </>
        )}

        { !!data.Destinatario && (
          <>
            <div className="d-block mt-3 mb-2">
              <strong>Destinatario</strong>
            </div>

            { !!data.Destinatario && data.Destinatario.map(renderDestinatario) }
          </>
        )}

        <div className="d-block mt-3 mb-2">
          <strong>Mercancias</strong>
        </div>

        { !!data.Mercancias && data.Mercancias.Mercancia.map(renderMercancias) }

        <Row className="pt-3">
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoComercioExteriorResumen;
